import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Componente para proteger rutas que requieren autenticación
 * Redirige a login si el usuario no está autenticado
 */
export default function ProtectedRoute({ children }) {
  // Verificar si el usuario está autenticado
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const user = localStorage.getItem('user');

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  // Si está autenticado, mostrar el componente hijo
  return children;
}